import { VehicleHandling } from './Vehicle';

export namespace VehicleHandlingProfiles {
  const normalTopSpeedX = 0.65;

  //#region Level 1

  export const heroLvl1: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.5,
    maxSpeedXPerMS: 1,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.5,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  export const villainLvl1: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.75,
    maxSpeedXPerMS: 1.2,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.25,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  //#endregion

  //#region Level 2

  export const heroLvl2: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.5,
    maxSpeedXPerMS: 1,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.5,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  export const villainLvl2: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.75,
    maxSpeedXPerMS: 1.2,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.25,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  //#endregion

  //#region Level 3

  export const heroLvl3: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.5,
    maxSpeedXPerMS: 1,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.5,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  export const villainLvl3: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.75,
    maxSpeedXPerMS: 1.2,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.25,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  //#endregion

  //#region Level 4

  export const heroLvl4: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.5,
    maxSpeedXPerMS: 1,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.5,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  export const villainLvl4: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.75,
    maxSpeedXPerMS: 1.2,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.25,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  //#endregion

  //#region Level 5

  export const heroLvl5: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.5,
    maxSpeedXPerMS: 1,
    accelerationYPerMS: 0.035,
    decelerationYPerMS: 0.015,
    topSpeedYPerMS: 0.5,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  export const villainLvl5: VehicleHandling = {
    accelerationXPerMS: 0.055,
    decelerationXPerMS: 0.01,
    topSpeedXPerMS: normalTopSpeedX,
    topBoostSpeedXPerMS: 0.75,
    maxSpeedXPerMS: 1.2,
    accelerationYPerMS: 0.05,
    decelerationYPerMS: 0.05,
    topSpeedYPerMS: 0.25,
    boostSpeedDecayRatePerMS: 0.006
  } as const;

  //#endregion
}
